import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggle', 'row']

  toggle(event) {
    const button = event.currentTarget
    const rowId = button.dataset.rowId
    const groupId = button.dataset.groupId

    if (rowId) {
      const row = document.getElementById(`row-${rowId}`)
      if (row) row.classList.toggle('expanded')
    }

    if (groupId) {
      const rows = this.element.querySelectorAll(`[data-group-id="${groupId}"]`)
      rows.forEach((row) => {
        row.classList.toggle('expanded')
      })
    }
  }
}
